var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRepricer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 8,
    fill: "white",
    fillOpacity: 0.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 20.5549C33.5 21.0524 37 24.8675 37 29.5V38.5H19V29.5C19 24.8675 22.5001 21.0524 27 20.5549V17.5H29V20.5549ZM35 36.5V29.5C35 25.634 31.866 22.5 28 22.5C24.134 22.5 21 25.634 21 29.5V36.5H35ZM28 34.5C25.2386 34.5 23 32.2614 23 29.5C23 26.7386 25.2386 24.5 28 24.5C30.7614 24.5 33 26.7386 33 29.5C33 32.2614 30.7614 34.5 28 34.5ZM28 32.5C29.6569 32.5 31 31.1569 31 29.5C31 27.8431 29.6569 26.5 28 26.5C26.3431 26.5 25 27.8431 25 29.5C25 31.1569 26.3431 32.5 28 32.5ZM28 30.5C27.4477 30.5 27 30.0523 27 29.5C27 28.9477 27.4477 28.5 28 28.5C28.5523 28.5 29 28.9477 29 29.5C29 30.0523 28.5523 30.5 28 30.5Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 55,
    height: 55,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.06
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepricer);
export default __webpack_public_path__ + "static/media/repricer.de8c2982453920f53f24840d204719bb.svg";
export { ForwardRef as ReactComponent };